module.exports = __webpack_public_path__ + "static/media/pencil.9928e5fd.svg";